import { Facade } from "./facade";
import { Observable } from "rxjs/Observable";
import { AppFacade } from "../services/app-facade/app-facade.service";
import { AppVersion } from "@ionic-native/app-version";
import { Platform } from "ionic-angular";
import { Headers, Http } from "@angular/http";
import { RequestOptionsArgs } from "@angular/http/src/interfaces";
import { of } from "rxjs/observable/of";

export class MetaFacade extends Facade {

    constructor(
        protected appFacade: AppFacade,
        protected http: Http,
        protected appVersion: AppVersion,
        protected platformService: Platform
    ) {
        super(appFacade);
    }

    getAppVersion(): Observable<string> {

        if (this.platformService.is("core")) {

            const headers = new Headers();

            headers.append("Accept", "text/xml");
            headers.append("Content-Type", "text/xml");

            return this.http.get(`${window.location.protocol}//${window.location.host}/config.xml`, {
                // responseType: ResponseContentType.Text,
                headers
            } as RequestOptionsArgs)
                .map(data => {
                    const parser = new DOMParser();

                    const text = data.text()
                        .replace(/\\"/g, "\"")
                        .replace(/\\'/g, "\"")
                        .replace(/\\n/g, "")
                        .replace(/^"/, "")
                        .replace(/"$/, "");

                    const xmlDoc = parser.parseFromString(text, "application/xml");
                    const widget = xmlDoc.getElementsByTagName("widget")[0];

                    if (!widget) {
                        return "";
                    }

                    try {
                        return widget.attributes.getNamedItem("version").value;
                    } catch (e) {
                        return "";
                    }
                })
                .catch(error => {
                    console.error(error);
                    return of("");
                });
        } else {
            return Observable.fromPromise(this.appVersion.getVersionNumber());
        }
    }
}



// WEBPACK FOOTER //
// ./src/core/facades/meta-facade.ts